import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

export function ObjectivesSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.objectives.title')}
      description={t('planWizard.sections.objectives.description')}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-653 - Objectives</p>
    </PlanSection>
  );
}

ObjectivesSection.displayName = 'ObjectivesSection';
